import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export const kpiType = createSlice({
  name: 'kpiType',
  initialState: localStorage.getItem('kpiType') !== null ? localStorage.getItem('kpiType') : 'Total shipped',
  reducers: {
    changeKpiType: (state, action: PayloadAction<string>) => {
      localStorage.setItem('kpiType', action.payload)
      return action.payload
    }
  }
})

export const { changeKpiType } = kpiType.actions
export default kpiType.reducer
